import React, { useEffect } from 'react';

import { Modal, Button } from '@sololearnorg/sol';
import useStyles from 'isomorphic-style-loader/useStyles';
import { Container } from '../../../../../symphony';

import { SolikDetectiveIcon } from './SolikDetectiveIcon';
import { SlDiscussContext } from '../../../global-constants';
import { SlActions } from '../../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../../global-interface';

import s from './PostQuestionSuccessModal.scss';

export function PostQuestionSuccessModal() {
  useStyles(s);
  const { actions$ } = Container.take(SlDiscussContext, SlActions);

  const handleClose = () => {
    actions$.next({
      type: ActionType.OnPostQuestionModalCloseClick,
      requestType: RequestType.Parallel,
    });
  };

  useEffect(() => {
    actions$.next({
      type: ActionType.OnPostQuestionModalMount,
      requestType: RequestType.Parallel,
    });
  }, []);

  return (
    <Modal.Custom
      dataTestid="mdlPostQuestion"
      onClose={handleClose}
      noPadding
      className="discuss-post-question"
    >
      <div className="discuss-post-question__wrapper">
        <h3 className="discuss-post-question__title">
          You successfully posted your question!
        </h3>
        <p className="discuss-post-question__text">
          While you wait for the answers, feel free to browse other
          questions.
        </p>
        <Button
          type="button"
          className="discuss-post-question__button"
          size="m"
          onClick={handleClose}
        >
          Continue
        </Button>
      </div>
    </Modal.Custom>
  );
}
